import React from "react";


export const CountryContext = React.createContext<{
    country: string | null;
    setCountry: React.Dispatch<React.SetStateAction<string | null>>;
}>({ country: null, setCountry: () => null });
